import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lc-photo-requirement-message',
  templateUrl: './photo-requirement-message.component.html',
  styleUrls: ['./photo-requirement-message.component.scss'],
  imports: [MatIcon],
})
export class PhotoRequirementMessageComponent {
  @Input() minimumPhotosRequired = 0;
  @Input() currentPhotoCount = 0;

  get photosStillRequired(): number {
    const remaining = this.minimumPhotosRequired - this.currentPhotoCount;
    return remaining > 0 ? remaining : 0;
  }

  get shouldShowMessage(): boolean {
    return this.minimumPhotosRequired > 0 && this.currentPhotoCount < this.minimumPhotosRequired;
  }
}
